import { EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { ErrorResponse } from '../_models/errorResponse';
import { CustomMessageModel } from '../_shared/custom-message/custom-message-model';
import { LoadingService } from './loading.service';

@Injectable({
	providedIn: 'root',
})
export class MessageService implements OnInit {

	private custom = Swal.mixin({
		showConfirmButton: true,
		showCloseButton: true
		// customClass: {
		//   cancelButton: 'btn btn-secondary margin-swal',
		//   confirmButton: 'btn btn-primary margin-swal'
		// }
	});

	ngOnInit(): void {
		this.hide();
	}

	private model: CustomMessageModel = { timer: 4000 } as CustomMessageModel;

	@Output()
	private fire: EventEmitter<CustomMessageModel> = new EventEmitter();

	constructor(private loadingService: LoadingService) {
	}

	hide() {
		this.model.show = false;

		this.fire.emit(this.model);
	}

	information(title: string, message: string) {
		this.custom.fire(title, message, 'info');
	}

	error(title: string, message: string) {
		this.custom.fire(title, message, 'error');
	}

	errorDefault() {
		this.custom.fire('Ocorreu um erro', 'Por favor, tente novamente mais tarde.', 'error');
	}

	customError(err: any) {
		this.loadingService.hide();
		if (err.status != '500') {
			if (err.error.erros) {
				let response = err.error as ErrorResponse;
				this.error('Ops!', response.erros.map(x => x.message).join(', '));
			}
			else {
				this.errorDefault();
			}

			return;
		}

		this.errorDefault();
	}

	warning(title: string, message: string) {
		this.custom.fire(title, message, 'warning');
	}

	question(title: string, message: string) {
		return this.questionCustom(title,message, 'Sim', 'Não');
	}

	questionWithJustification(title: string, message: string) {
		return this.custom.fire({
			title,
			text: message,
			icon: 'warning',
			input: 'textarea',
			inputLabel: 'Justificativa',
			inputPlaceholder: 'Informe a justificativa',
			inputAttributes: {
				maxlength: '500',
			},
			showCancelButton: true,
			confirmButtonText: 'Excluir',
			cancelButtonText: 'Cancelar',
			preConfirm: (value) => {
				if (!value?.trim()) {
					Swal.showValidationMessage('A justificativa é obrigatória.');
				}
				return value?.trim();
			},
		});
	}

	questionCustom(title: string, message: string, confirm: string, cancel: string) {
		return this.custom.fire({
			title: title,
			text: message,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: confirm,
			cancelButtonText: cancel
		});
	}

	success(title: string, message: string) {
		this.custom.fire(title, message, 'success');
	}

	show(message: string) {
		this.model.timer = 4000;
		this.model.show = true;
		this.model.message = message;

		this.fire.emit(this.model);
	}

	showFixed(message: string) {
		this.model.timer = -1;
		this.model.show = true;
		this.model.message = message;

		this.fire.emit(this.model);
	}


	getEmittedValue() {
		return this.fire;
	}

}
